/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Casmanagement_Title1Inputs */

const en_settings_casmanagement_title1 = /** @type {(inputs: Settings_Casmanagement_Title1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`CAS Management`)
};

/**
* | output |
* | --- |
* | "CAS Management" |
*
* @param {Settings_Casmanagement_Title1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_casmanagement_title1 = /** @type {((inputs?: Settings_Casmanagement_Title1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Casmanagement_Title1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_casmanagement_title1(inputs)
});
export { settings_casmanagement_title1 as "settings_casManagement_title" }